/**
 * Layout Engine module
 */
import {NgModule} from '@angular/core';
import {LayoutEngineComponent} from './components/layout-engine/layout-engine.component';
import {LayoutEngineService} from './services/layout-engine.service';
import {DynamicFormModule} from '@ispm/dynamic-form/dynamic-form.module';
import {CoreModule} from '@ispm/core/core.module';
import {TimelineModule} from '@ispm-client/modules/timeline';

@NgModule({
  imports: [
    CoreModule,
    DynamicFormModule,
    TimelineModule
  ],
  declarations: [
    LayoutEngineComponent

  ],
  providers: [LayoutEngineService],
  exports: [LayoutEngineComponent]


})
export class LayoutEngineModule { }
